import { ArrowUpRight } from "lucide-react";
import { BrandLockup } from "./BrandLockup";
import { scrollToId } from "../lib/scroll";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[#34d186]/15 bg-[#fafafa]">
      <div className="mx-auto flex max-w-7xl flex-col gap-12 px-5 py-16 sm:px-8 md:flex-row md:items-start md:justify-between">
        <div className="max-w-sm">
          <BrandLockup />
          <p className="mt-5 text-sm leading-relaxed text-[#737373]">
            Formação certificada de motoristas TVDE com acompanhamento para te tornares motorista Bolt.
            Reconhecido pelo IMT.
          </p>
          <a
            href="https://grupoift.pt/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-ift-website-link"
            className="group mt-6 inline-flex items-center gap-2 rounded-full border border-[#34d186]/40 px-5 py-2.5 text-sm font-semibold text-[#171717] transition-colors duration-300 hover:border-[#34d186] hover:text-[#00c46a]"
          >
            Visitar grupoift.pt
            <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </a>
        </div>
        <div className="flex flex-wrap gap-16">
          <div>
            <p className="mb-4 font-mono-x text-[10px] uppercase tracking-[0.3em] text-[#34d186]">Navegação</p>
            <ul className="space-y-2.5 text-sm text-[#737373]">
              <li><button data-testid="footer-link-programa" onClick={() => scrollToId("programa")} className="transition-colors duration-300 hover:text-[#34d186]">O Programa</button></li>
              <li><button data-testid="footer-link-precos" onClick={() => scrollToId("precos")} className="transition-colors duration-300 hover:text-[#34d186]">Preços</button></li>
              <li><button data-testid="footer-link-inscricao" onClick={() => scrollToId("inscricao")} className="transition-colors duration-300 hover:text-[#34d186]">Inscrição</button></li>
              <li><button data-testid="footer-link-faq" onClick={() => scrollToId("faq")} className="transition-colors duration-300 hover:text-[#34d186]">FAQ</button></li>
            </ul>
          </div>
          <div>
            <p className="mb-4 font-mono-x text-[10px] uppercase tracking-[0.3em] text-[#34d186]">Formações</p>
            <ul className="space-y-2.5 text-sm text-[#737373]">
              <li>Formação Inicial · 155€</li>
              <li>Renovação · 67.50€</li>
            </ul>
          </div>
          <div>
            <p className="mb-4 font-mono-x text-[10px] uppercase tracking-[0.3em] text-[#34d186]">Grupo IFT</p>
            <ul className="space-y-2.5 text-sm text-[#737373]">
              <li>
                <a href="https://grupoift.pt/" target="_blank" rel="noopener noreferrer" data-testid="footer-link-grupoift" className="transition-colors duration-300 hover:text-[#00c46a]">
                  grupoift.pt
                </a>
              </li>
              <li>inovar. fazer. transformar.</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-black/5">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-5 py-6 text-xs text-[#737373]/70 sm:flex-row sm:items-center sm:justify-between sm:px-8">
          <span>© {new Date().getFullYear()} Grupo IFT · Todos os direitos reservados</span>
          <span>Política de Privacidade · Os teus dados são usados apenas para contacto sobre o curso</span>
        </div>
      </div>
    </footer>
  );
}
